export const MIN_CHANNEL_BUDGET = 50;
export const ROUNDING_TOLERANCE = 1;
export const MIN_JOB_DESCRIPTION_LENGTH = 250;
